import { PrimaryButton } from '@theme/components/Button/src/tsx/Button';
import PropTypes from 'prop-types';
import TextTransition from 'react-text-transition';
import Select from '../../../Form/src/jsx/Select';
import List from './List';
import Link from './ui/Link';

export default function Plan({
	bottomLink = {},
	buttonLabel = '',
	description = '',
	featureListItems = [],
	highlight = '',
	loading = false,
	onButtonClick = () => {},
	price = '',
	priceExplanation = '',
	priceInterval = '',
	pricePerUnit = '',
	unitSelect = { name: '', label: '', onChange: () => {}, options: [], value: '' },
	featureListHeading = '',
}) {
	const wrapperClasses = ['prc-plan'];
	if (highlight) wrapperClasses.push('prc-plan--most-popular');

	const skeletonAttributes = {};
	if (loading) skeletonAttributes['data-loading'] = loading;

	return (
		<div className={wrapperClasses.join(' ')}>
			{highlight && <div className="prc-plan__badge">{highlight}</div>}

			<div className="prc-plan__actions">
				<div className="prc-plan__price">
					<h3 className="total" {...skeletonAttributes}>
						<TextTransition inline={true}>{price}</TextTransition>
					</h3>
					<span className="interval">{priceInterval}</span>
					<span className="explanation">{priceExplanation}</span>
					{pricePerUnit && <div className="price-per-unit">{pricePerUnit}</div>}
				</div>
				<div className="prc-plan__units">{Object.keys(unitSelect).length ? <Select {...unitSelect} testId="prc-select-units" /> : null}</div>
				<PrimaryButton onClick={onButtonClick} testId="prc-button-choose-plan">
					{buttonLabel}
				</PrimaryButton>
			</div>

			<div className="prc-plan__information">
				{loading ? (
					<span className="skeleton__elem skeleton__elem--text-short"></span>
				) : (
					<p className="prc-plan__description" dangerouslySetInnerHTML={{ __html: description }} />
				)}
				{featureListItems.length || loading ? (
					<div className="prc-plan__features">
						<p>{featureListHeading}</p>
						{loading ? (
							<ul className="skeleton skeleton--list">
								<li className="skeleton__elem skeleton__elem--text-long"></li>
								<li className="skeleton__elem skeleton__elem--text-short"></li>
								<li className="skeleton__elem skeleton__elem--text-long"></li>
								<li className="skeleton__elem skeleton__elem--text-short"></li>
							</ul>
						) : (
							<List items={featureListItems} useCheckmarks={true} />
						)}
					</div>
				) : null}
				{bottomLink.href && (
					<div className="prc-plan__feature-link">
						<Link href={bottomLink.href} onClick={bottomLink.onClick ? bottomLink.onClick : () => {}}>
							{bottomLink.label}
						</Link>
					</div>
				)}
			</div>
		</div>
	);
}

Plan.propTypes = {
	bottomLink: PropTypes.object,
	buttonLabel: PropTypes.string,
	description: PropTypes.string,
	featureListItems: PropTypes.array,
	highlight: PropTypes.string,
	loading: PropTypes.bool,
	onButtonClick: PropTypes.func,
	price: PropTypes.string,
	priceExplanation: PropTypes.string,
	priceInterval: PropTypes.string,
	pricePerUnit: PropTypes.string,
	unitSelect: PropTypes.object,
	featureListHeading: PropTypes.string,
};
